import { createSelector } from 'reselect';

export const selectDiscountCode = (id) =>
  createSelector(
    (state) => state.DiscountCode.discountCodes,
    (discountCodes) =>
      discountCodes.find((discountCode) => discountCode.id === id),
  );

export const selectActiveDiscountCodes = createSelector(
  (state) => state.DiscountCode.discountCodes,
  (discountCodes) =>
    discountCodes.filter((discountCode) => discountCode.isActive),
);

export const selectValidDiscountCodes = createSelector(
  (state) => state.DiscountCode.discountCodes,
  (discountCodes) =>
    discountCodes.filter((discountCode) => {
      if (!discountCode.isActive) return false;

      // Check expiration
      if (
        discountCode.expirationDate &&
        discountCode.expirationDate < new Date()
      ) {
        return false;
      }

      // Check usage limits
      if (
        discountCode.maxUses &&
        discountCode.currentUses >= discountCode.maxUses
      ) {
        return false;
      }

      return true;
    }),
);

export const totalDiscountCodes = createSelector(
  (state) => state.DiscountCode.discountCodes,
  (discountCodes) => discountCodes.length,
);

export const totalActiveDiscountCodes = createSelector(
  selectActiveDiscountCodes,
  (activeDiscountCodes) => activeDiscountCodes.length,
);

export const selectDiscountCodeByCode = (code) =>
  createSelector(
    (state) => state.DiscountCode.discountCodes,
    (discountCodes) =>
      discountCodes.find(
        (discountCode) => discountCode.code === code?.toUpperCase(),
      ),
  );

export const selectDiscountCodeValidationData = createSelector(
  (state) => state.DiscountCode.validatedDiscount,
  (validatedDiscount) => validatedDiscount,
);

export const selectDiscountCodeLoading = createSelector(
  (state) => state.DiscountCode.loading,
  (loading) => loading,
);

export const selectDiscountCodeError = createSelector(
  (state) => state.DiscountCode.error,
  (error) => error,
);

export const selectDiscountCodeMessage = createSelector(
  (state) => state.DiscountCode.message,
  (message) => message,
);
